import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/pricing/page.tsx");
